export default __webpack_public_path__ + "static/media/6_Rooms.bb8770a2.png";